import GSAP from 'gsap';

export default class Menu {
    constructor() {
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu'),
            links: document.querySelectorAll('#main-menu a'),
            linksMobile: document.querySelectorAll('#mega-menu-mobile .menu-first-level a'),
            subLinksMobile : document.querySelectorAll('#mega-submenu-mobile .content .nav .nav-item'),
            subDropdownMobile : document.querySelectorAll('#mega-submenu-mobile .content .nav .nav-item .dropdown-menu'),
            megaMenu: document.getElementById('mega-menu'),
            megaMenuMobile : document.getElementById('mega-menu-mobile'),
            megaSubMenuMobile : document.getElementById('mega-submenu-mobile'),
            btnCloseSubMenuMobile : document.getElementById('btn-close-sub-mega-mobile')
        }
        this.filter = {
            container_references: document.getElementById('filter-container-references'),
        };
        app.overlay = document.querySelector('.app-overlay');
        this.body = document.querySelector('body');

        this.lang = {
            toggler: document.querySelector('#select-language .dropdown-toggler'),
            menu: document.querySelector('#select-language .dropdown-menu'),
        }
        this.activeMenu = {
            header: document.querySelector('header .navbar'),
            activePage: document.querySelector('header .navbar .active-page'),
        }
        this.search = {
            toggler: document.getElementById('search-toggler'),
            main: document.getElementById('search'),
        }
    }

    init() {
        this.toggle();
        // if(this.lang.toggler){ this.language(); }
    }

    toggle = () => {

        // helper navigation menu
        if (this.activeMenu.activePage) {
            var activeMenu = this.activeMenu.activePage.parentNode.parentNode.parentNode.parentNode.parentNode;
            var togglerActive = document.querySelector('[data-slug="'+activeMenu.getAttribute('data-slug')+'"]')
            togglerActive.classList.add('nav-link-active-page'); 
        }

        var megaSubContent = this.menu.megaSubMenuMobile.querySelectorAll('.content');
        
        // close all menu mobile
        this.menu.toggler.addEventListener('click', () => {
            // this.menu.main.classList.toggle('active');
            this.menu.toggler.classList.toggle('active');
            this.menu.megaMenuMobile.classList.toggle('active');
            this.menu.megaSubMenuMobile.classList.remove('active');
            this.body.classList.toggle('overflow-hidden');
            this.menu.subLinksMobile.forEach((item) =>{
                item.classList.remove('active');
            });
            this.menu.subDropdownMobile.forEach((submenu) =>{
                if (submenu.classList.contains('active')) {
                    submenu.classList.remove('active')
                }
            });

            // this.menu.subDropdownMobile.classList.remove('active');
            // this.body.classList.toggle('hidden');
            app.overlay.classList.toggle('active');
            // this.lang.menu.classList.remove('show');
            megaSubContent.forEach((menu) => { 
                GSAP.set(menu, {
                    x: -50,
                    autoAlpha: 0,
                    delay: .2,
                    duration: .4,
                })
            });
        });

        this.menu.subLinksMobile.forEach((link) =>{
            link.addEventListener('click', (e) => {
                // e.preventDefault();
                this.menu.subLinksMobile.forEach((item) =>{
                    item.classList.remove('active');
                });

                this.menu.subDropdownMobile.forEach((dropdown) => {
                    dropdown.classList.remove('active');
                });
                
                if(e.target.classList.contains('active')){
                    e.target.classList.remove('active');
                    e.target.querySelector('.dropdown-menu').classList.remove('active');
                } else {
                    e.target.classList.add('active');
                    e.target.querySelector('.dropdown-menu').classList.add('active');
                }

            })
        });
        
        // mega submenu mobile
        megaSubContent.forEach((menu) => { 
            GSAP.set(menu, {
                x: -50,
                autoAlpha: 0,
            })
        });

        this.menu.linksMobile.forEach((link) =>{
            if (link.getAttribute('href') == '#') {
                link.addEventListener('click', (e) => {
                    var slug = e.target.getAttribute('data-slug');
                    var mega = this.menu.megaSubMenuMobile.querySelector('[data-slug="'+slug+'"]');
                    
                    e.preventDefault();
                    this.menu.megaSubMenuMobile.classList.add('active');
                    //     // Add active-state to menus
                    megaSubContent.forEach((menu) => { 
                        GSAP.to(menu, {
                            duration: .3,
                            x: -50,
                            autoAlpha: 0,
                            onStart: () => { 
                                menu.classList.add('d-none');
                                mega.style.opacity = 0;
                                mega.classList.remove('d-none');
                            }
                        })
                    });
    
                    GSAP.to(mega, {
                        delay: .3,
                        duration: .3,
                        x: 0,
                        autoAlpha: 1,
                    })
                });
            }
        })

        // close megaSubMenuMobile
        this.menu.btnCloseSubMenuMobile.addEventListener('click', () => {
            this.menu.megaSubMenuMobile.classList.remove('active');
            this.menu.subLinksMobile.forEach((item) =>{
                item.classList.remove('active');
            });
            this.menu.subDropdownMobile.forEach((submenu) =>{
                if (submenu.classList.contains('active')) {
                    submenu.classList.remove('active')
                }
            });
            megaSubContent.forEach((menu) => { 
                GSAP.set(menu, {
                    x: -50,
                    autoAlpha: 0,
                    delay: .2,
                    duration: .4,
                })
            });
        });

        
        // mega menu deskstop
        var megaContent = this.menu.megaMenu.querySelectorAll('.content');

        megaContent.forEach((menu) => { 
            GSAP.set(menu, {
                y: -50,
                autoAlpha: 0,
            })
        });

        this.menu.links.forEach((link) =>{
            if (link.getAttribute('href') == '#'){

                link.addEventListener('click', (e) => {
                    var slug = e.target.getAttribute('data-slug');
                    var mega = this.menu.megaMenu.querySelector('[data-slug="'+slug+'"]');
    
                    e.preventDefault();
    
                    
                    if(e.target.classList.contains('item-select')){
                        app.overlay.classList.remove('active');
                        this.body.classList.remove('overflow-hidden');
                        this.menu.links.forEach((nav_item)=>{ nav_item.classList.remove('item-select'); });
                        GSAP.to(mega, {
                            y: -30,
                        });
                        GSAP.to(mega, {
                            duration: .2,
                            autoAlpha: 0,
                            onComplete: () => {  mega.classList.add('d-none'); }
                        });
                        this.menu.megaMenu.classList.remove('mega-menu-open');
                    } else {
                        app.overlay.classList.add('active');
                        this.body.classList.add('overflow-hidden');
    
                        // Active States > Links
                        this.menu.links.forEach((nav_item)=>{ nav_item.classList.remove('item-select'); });
                        e.target.classList.add('item-select')
                        
                        // Add active-state to menus
                        megaContent.forEach((menu) => { 
                            GSAP.to(menu, {
                                y: -30,
                                onStart: () => { 
                                    menu.classList.add('d-none');
                                    mega.style.opacity = 0;
                                    mega.classList.remove('d-none');
                                }
                            })
                            GSAP.to(menu, {
                                duration: .2,
                                autoAlpha: 0,
                                onStart: () => { 
                                    menu.classList.add('d-none');
                                    mega.style.opacity = 0;
                                    mega.classList.remove('d-none');
                                }
                            })
                        });
    
                        GSAP.to(mega, {
                            y: 0,
                        })
                        GSAP.to(mega, {
                            delay: .4,
                            duration: .2,
                            autoAlpha: 1,
                        })
                        
                        if(!this.menu.megaMenu.classList.contains('mega-menu-open')){
                            this.menu.megaMenu.classList.add('mega-menu-open');
                        }
                    }
                });
            }

        })

        app.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            app.overlay.classList.remove('active');
            this.body.classList.remove('overflow-hidden');
            this.menu.megaMenu.classList.remove('mega-menu-open');
            this.menu.links.forEach((nav_item)=>{ nav_item.classList.remove('item-select'); });
            megaContent.forEach((menu) => { menu.style.opacity = 0; });
            this.search.main.classList.add('hidden-search');
            this.filter.container_references.classList.remove('active-references');
        })
    }

    language = () => {
        this.lang.toggler.addEventListener('click', () => {
            this.lang.menu.classList.toggle('show');

        });
    }
}
